import hydraTopicConfig from './hydra-topic-config.json';
// import Logger from './logger';


export const modeStringToModeCode =
  Object.entries(hydraTopicConfig)
    .reduce((acc, [_messageType, { mode, code }]) => {
      return { ...acc, [mode]: code };
    }, {});


export const modeCodeToModeString =
  Object.entries(modeStringToModeCode)
    .reduce((acc, [modeString, modeCode]) => {
      return { ...acc, [modeCode]: modeString };
    }, {});


export function getSubscriptionTopic({ messageType, payload = {} }) {
  if (!(messageType in hydraTopicConfig)) {
    throw `${messageType} not supported`;
  }

  const privateMessageTypes = ['ClientAlerts', 'Notifications', 'OrderUpdate', 'TradeUpdate', 'AdminMessage', 'PositionUpdate','FundsUpdate','SocketMessage','BrokerageMessage', 'EquityMarginAlert'];
  if (privateMessageTypes.includes(messageType)) {
        return `${messageType}`;
  }

  // const { mode, code } = hydraTopicConfig[messageType];
  const instrumentUpdates = ['DetailMarketDataMessage', 'CompactMarketDataMessage', "AuctionMarketDataMessage", 'SnapquoteDataMessage', 'TbtSnapquoteDataMessage', 'SpreadMarketUpdate', 'TbtUpdate', 'GreekData'];
  if (instrumentUpdates.includes(messageType)) {
    const { exchangeCode, instrumentToken } = payload;
    if (!exchangeCode || !instrumentToken) {
      throw `missing exchangeCode: ${exchangeCode} or instrumentToken: ${instrumentToken}`;
    }
    return `${messageType}/${exchangeCode}/${instrumentToken}`;
  }

  const exchangeUpdates = ['MktStatus', 'ExchangeMessage',"SocketMessage","BrokerageMessage"];
  if (exchangeUpdates.includes(messageType)) {
    const { exchangeCode } = payload;
    if (!exchangeCode) {
      throw `missing exchangeCode: ${exchangeCode}`;
    }
    return `${messageType}/${exchangeCode}`;
  }

  throw `invalid messageType: ${messageType}`;
}

// supported actionType: subscribe, unsubscribe
export function getSocketPublishObject({ messageType, actionType, payload = {} }) {
  switch (messageType) {
    case 'SpreadMarketUpdate':
      return {
        a: actionType,
        v: [[payload.exchangeCode, payload.instrumentToken]],
        m: 'spreaddata'
      };
    case 'DetailMarketDataMessage':
      return {
        a: actionType,
        v: [[payload.exchangeCode, payload.instrumentToken]],
        m: 'marketdata'
      };
    case 'AuctionMarketDataMessage':
      return {
        a: actionType,
        v: [[payload.exchangeCode, payload.instrumentToken]],
        m: 'auction_marketdata'
      };
    case 'CompactMarketDataMessage':
      return {
        a: actionType,
        v: [[payload.exchangeCode, payload.instrumentToken]],
        m: 'compact_marketdata'
      };
    case 'SnapquoteDataMessage':
      return {
        a: actionType,
        v: [[payload.exchangeCode, payload.instrumentToken]],
        m: 'full_snapquote'
      };
    case 'TbtSnapquoteDataMessage':
      return {
        a: actionType,
        v: [[payload.exchangeCode, payload.instrumentToken]],
        m: 'tbt_full_snapquote'
      };
    case 'OrderUpdate':
      return {
        a: actionType,
        v: [localStorage.getItem('login_id'), "web"],
        m: 'updates'
      };
    case 'ClientAlerts':
      // Price-alert push notifications. Shares the "updates" channel with
      // Order/Trade/Position updates (hydra-topic-config code 5002).
      return {
        a: actionType,
        v: [localStorage.getItem('login_id'), "web"],
        m: 'updates'
      };
    case 'Notifications':
      // Canonical messageType used by captur for triggered alerts —
      // ships on the same "updates" channel (hydra-topic-config code 65).
      return {
        a: actionType,
        v: [localStorage.getItem('login_id'), "web"],
        m: 'updates'
      };
    case 'TradeUpdate':
      return {
        a: 'subscribe',
        v: [localStorage.getItem('login_id'), "web"],
        m: 'updates'
      };
    case 'ExchangeMessage':
      return {
        a: actionType,
        v: [payload.exchangeCode],
        m: 'exchange_messages'
      };
    case 'PositionUpdate':
      return {
        a: 'subscribe',
        v: [localStorage.getItem('login_id'), "web"],
        m: 'position_updates'
      };
    case 'FundsUpdate':
      return {
        a: 'subscribe',
        v: [localStorage.getItem('login_id'), "web"],
        m: 'cash_updates'
      };
    case 'GreekData':
      return {
        a: 'subscribe',
        v: [[payload.exchangeCode, payload.instrumentToken]],
        m: 'greekdata'
      };
    case 'EquityMarginAlert':
      return {
        a: 'subscribe',
        v: [localStorage.getItem('login_id'), "web"],
        m: 'equity_margin_alert_updates'
      };
    default:
      return {};
  }
}
